<template>
  <v-dialog v-model="deleteDialog" max-width="600" persistent>
    <v-progress-linear
      v-if="deleteLoading"
      indeterminate
    ></v-progress-linear>
    <v-card class="ma-auto pa-lg-2 deleteAccount" elevation="1">
      <v-card-title class="h2 title text-center heading">
        Delete {{ deleteType }}
      </v-card-title>
      <v-card-subtitle class="mt-2 px-6 font-weight-medium">
        Are you sure of this action? <br />
        This {{ deleteType }} will be deleted
      </v-card-subtitle>
      <v-card-actions class="mx-lg-2 mt-5">
        <v-spacer />
        <v-btn
          :disabled="deleteLoading"
          color="primary"
          outlined
          small
          @click="cancelDelete"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="deleteLoading"
          :loading="deleteLoading"
          class="white--text"
          color="red"
          small
          @click="deleteItem()"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    deleteLoading: {
      type: Boolean,
      default: () => false
    },
    deleteDialog: {
      type: Boolean,
      default: () => false
    },
    deleteType: {
      type: String,
      default: () => "Item",
      required: true
    }
  },
  methods: {
    deleteItem() {
      this.$emit("deleteItem", { isReviews: this.deleteType === 'review'});
    },
    cancelDelete(){
     this.$emit("cancelDelete");
    }
  },
};
</script>

<style>
</style>
